import React from "react";
import Header from "../../../../../dev/terminal/containers/header";
import Popup from "../../../../../dev/terminal/containers/popup";
import Betslip from "../../../../../dev/terminal/components/betslip";
import ProfileHandler from "../../../../../dev/terminal/components/userProfileSubscriber";
import Loader from "../../../../../dev/terminal/components/loader";
import Config from "../../../../../dev/config/main";

export default function layoutTemplate () {
    let { location } = this.props,
        disabledHeader = location.pathname === "/admin",
        disabledBetslip = location.pathname === "/admin" 
            || location.pathname.includes( "/casino") || location.pathname.includes("/dealer") || location.pathname === "/casino/Favorites", // used includes function for /casino/ and /dealer/ cases
        enableClassicViewBetslip = location.pathname.indexOf("prematch") > 0 ||
            location.pathname.indexOf("live") > 0 ||
            location.pathname.indexOf("today") > 0 ||
            location.pathname.indexOf("horseRacing") > 0 ||
            location.pathname.indexOf("greyhounds") > 0 ||
            location.pathname.indexOf("thirdPartyGame") > 0 || location.pathname.indexOf("virtualGames") > 0 ||
            location.pathname.indexOf("topGames") > 0 ||
            location.pathname.indexOf("lottery") > 0,
        horseGrayhoundStyles = location.pathname.indexOf("horseRacing") > 0 ||
        location.pathname.indexOf("greyhounds") > 0 || location.pathname.indexOf("virtualGames") > 0;
    return (
        this.props.appReady // start rendering only when application is ready (translations/config/etc are loaded)
            ? <div className={`terminal-wrapper ${(enableClassicViewBetslip) && "asianBetslipStatic"} `} onClick={this.handleClick}>
                {!disabledHeader ? <Header {...this.props}/> : null}
                <div className="content-wrapper-t">
                    <div className={`scroll-container-t ${Config.terminal.scrollButtons && "scroll-b-view"}`}>
                        {this.props.children}
                        {this.props.user && !this.props.user.loginInProgress && this.props.user.loggedIn ? <ProfileHandler /> : (null)}
                    </div>
                </div>
                <Betslip className={horseGrayhoundStyles ? "horseGrayhoundStyles" : ''} disableBetslip={!disabledBetslip}/>
                <Popup/>
            </div>
            : <Loader/>
    );
};